"use strict";
const scrollWrapper = document.getElementById('scrollTopWrapper');
const scrollButton = document.getElementById('scrollTopButton');
const progressRing = document.getElementById('progressRingFill');
const topDistance = 600;
const radius = 23;
const circumference = 2 * Math.PI * radius;

if (progressRing) {
    progressRing.style.strokeDasharray = `${circumference}`;
    progressRing.style.strokeDashoffset = `${circumference}`;
}

if (scrollWrapper && scrollButton) {
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > topDistance) {
            scrollWrapper.classList.add('scrolltop--show');
            scrollWrapper.classList.remove('scrolltop--hide');
        } else {
            scrollWrapper.classList.add('scrolltop--hide');
            scrollWrapper.classList.remove('scrolltop--show');
        }
    });

    scrollButton.addEventListener('click', () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });

    function updateScrollProgress() {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollPercent = scrollY / (documentHeight - windowHeight);
        const offset = circumference - (scrollPercent * circumference);
        if (progressRing) {
            progressRing.style.strokeDashoffset = offset;
        }
    }

    window.addEventListener('scroll', updateScrollProgress);
}